import { Component, OnDestroy, OnInit } from '@angular/core';
import { DriversService } from '../../../drivers/drivers-service/drivers-service';
import { FormBuilder } from '@angular/forms';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { MoneyForBuckService } from 'src/app/service/money-for-buck-service/money-for-buck.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';
import * as moment from 'moment';
import { CsvService } from 'src/app/service/csv-service/csv.service';

@Component({
  selector: 'app-mfb-dashboard',
  templateUrl: './mfb-dashboard.component.html',
  styleUrls: ['./mfb-dashboard.component.css']
})
export class MfbDashboardComponent implements OnInit, OnDestroy {

  user;
  timeZone;
  buckList = [];
  submitted = false;
  todayDate = [];
  search;
  driverModalObj;
  driverTrips;
  sourceType;
  constructor(
    private sharedDataService: SharedDataService,
    private mfbService: MoneyForBuckService,
    private csvService:CsvService
  ) { }

  ngOnInit() {
    this.getUser()
  }



  getUser() {
    this.sharedDataService
      .getUser()
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = user.timeZone;
          this.todayDate = [
            moment.tz(this.timeZone).startOf("day").toISOString(),
            moment.tz(this.timeZone).endOf("day").toISOString(),
          ];
          this.getDashboardBucks();

        }
      });
  }

  getDashboardBucks() {
    const queryParams = {
      scheduleTime : this.todayDate[0] + ',' + this.todayDate[1],
    }
    this.mfbService
      .getDashboard(queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.buckList = data.assigns
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }


  onDateChange(event) {
    this.todayDate = [
      event[0].toISOString(),
      event[1].endOf("day").toISOString(),
    ];
      this.getDashboardBucks();
  }

  downloadCSV(source){
    this.sourceType = source
    if(this.buckList && this.todayDate){
      this.csvService.downloadMoneyForBuckReport(this.buckList,this.todayDate,this.timeZone, this.sourceType)
    }
  }

  openDriverTrips(data){
    this.driverModalObj = data;
    this.driverTrips = data.trips;
  }

  ngOnDestroy(): void {
  }
}
